import { useCallback, useEffect, useState } from 'react';

export const formatCamelCase = (text: string) => {
  return text
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^[a-z]/, (char) => char.toUpperCase());
};

export const isValidZipCode = (zipCode: string): boolean =>
  /^\d{5}$/.test(zipCode);

export const updateFilter = <
  T extends Record<string, string | number | boolean | null | undefined>
>(
  filters: T,
  setFilters: React.Dispatch<React.SetStateAction<T>>,
  key: keyof T,
  value: T[keyof T]
): void => {
  setFilters((prev) => ({ ...prev, [key]: value }));
};

type offerParams = {
  offerTotal: number;
  offerPosition: number;
};

export const useSkuViewedUrl = (
  originalUrl: string,
  skuViewedPayload?: any,
  offerParams?: offerParams
) => {
  const [url, setUrl] = useState(originalUrl);

  useEffect(() => {
    if (skuViewedPayload) {
      const encodedSkuPayload = encodeURIComponent(
        btoa(JSON.stringify(skuViewedPayload))
      );
      const enrichedUrl = new URL(originalUrl);
      enrichedUrl.searchParams.append('skuViewedPayload', encodedSkuPayload);
      setUrl(enrichedUrl.toString());
    }
  }, [skuViewedPayload, originalUrl]);

  return useCallback(
    (ctaType?: string, destinationUrl?: string) => {
      const typedUrl = new URL(url);
      if (offerParams) {
        typedUrl.searchParams.append(
          'offerTotal',
          offerParams.offerTotal.toString()
        );
        typedUrl.searchParams.append(
          'offerPosition',
          offerParams.offerPosition.toString()
        );
      }
      if (ctaType) {
        typedUrl.searchParams.append('ctaType', ctaType);
      }
      if (destinationUrl) {
        const encodedDestinationUrl = encodeURIComponent(destinationUrl);
        typedUrl.searchParams.append('destinationUrl', encodedDestinationUrl);
      }
      return typedUrl.toString();
    },
    [url, offerParams]
  );
};
